import React from "react";
import {
  Box,
  Divider,
  Grid,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Footer = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const linkItems = [
    { name: "Home", to: "/", onClick: () => console.log("Home clicked") },

    {
      name: "Events",
      // to: "/events",
      onClick: () => console.log("Events clicked"),
    },
    {
      name: "Gallery",
      // to: "/gallery",
      onClick: () => console.log("Courses clicked"),
    },
    {
      name: "Blogs",
      // to: "/blogs",
      onClick: () => console.log("Contact Us clicked"),
    },
  ];

  const aboutItems = [
    {
      name: "About Us",
      to: "/about-us",
      onClick: () => console.log("About Us clicked"),
    },
    {
      name: "Our Programs",
      to: "/our-programs",

      onClick: () => console.log("Gallery clicked"),
    },
    {
      name: "Why Join podar prep ",
      to: "/why-join-podar-prep-yelahanka",
      onClick: () => console.log("News clicked"),
    },
    {
      name: "Contact Us",
      to: "/contact-us",
      onClick: () => console.log("Contact Us clicked"),
    },
  ];

  const socialLinks = [
    { icon: WhatsAppIcon, url: "https://wa.me/1234567890" },
    { icon: FacebookIcon, url: "https://facebook.com" },
    { icon: TwitterIcon, url: "https://twitter.com" },
    { icon: GoogleIcon, url: "https://google.com" },
    { icon: YouTubeIcon, url: "https://youtube.com" },
    { icon: LinkedInIcon, url: "https://linkedin.com" },
    { icon: InstagramIcon, url: "https://instagram.com" },
    { icon: PinterestIcon, url: "https://pinterest.com" },
  ];

  return (
    <Box sx={{ position: "relative", overflow: "hidden" }}>
      <Box
        sx={{
          backgroundColor: "#1d67ab",
          color: "#fff",
          p: isSmallScreen ? 3 : 8,
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent={isSmallScreen ? "center" : "space-between"}
        >
          {/* Links Section */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography sx={{ fontSize: "20px", fontWeight: "bold", mb: 2 }}>
              Links
            </Typography>
            <Divider
              sx={{
                width: "50px",
                borderWidth: "2px",
                backgroundColor: "#8c8587",
                mb: 2,
              }}
            />
            {linkItems.map(({ name, to, onClick }, index) => (
              <Box
                display="flex"
                alignItems="center"
                key={index}
                sx={{ mt: 1 }}
              >
                <ArrowRightIcon sx={{ fontSize: "16px", mr: 1 }} />
                <Link
                  to={to}
                  style={{ color: "#fff", textDecoration: "none" }}
                  onClick={onClick}
                >
                  <Typography
                    sx={{ fontSize: 15, ":hover": { color: "#fdce0d" } }}
                  >
                    {name}
                  </Typography>
                </Link>
              </Box>
            ))}
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography sx={{ fontSize: "20px", fontWeight: "bold", mb: 2 }}>
              About
            </Typography>
            <Divider
              sx={{
                width: "50px",
                borderWidth: "2px",
                backgroundColor: "#8c8587",
                mb: 2,
              }}
            />
            {aboutItems.map(({ name, to, onClick }, index) => (
              <Box
                display="flex"
                alignItems="center"
                key={index}
                sx={{ mt: 1 }}
              >
                <ArrowRightIcon sx={{ fontSize: "16px", mr: 1 }} />
                <Link
                  to={to}
                  style={{ color: "#fff", textDecoration: "none" }}
                  onClick={onClick}
                >
                  <Typography
                    sx={{ fontSize: 15, ":hover": { color: "#fdce0d" } }}
                  >
                    {name}
                  </Typography>
                </Link>
              </Box>
            ))}
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography sx={{ fontSize: "20px", fontWeight: "bold", mb: 2 }}>
              Follow Us
            </Typography>
            <Divider
              sx={{
                width: "50px",
                borderWidth: "2px",
                backgroundColor: "#8c8587",
                mb: 2,
              }}
            />
            <Box
              sx={{
                display: "flex",
                gap: "8px",
                justifyContent: "start",
                flexWrap: "wrap",
              }}
            >
              {socialLinks.map(({ icon: Icon, url }, index) => (
                <IconButton
                  key={index}
                  onClick={() => window.open(url, "_blank")}
                  sx={{
                    color: "#fff",
                    width: "30px",
                    height: "35px",
                    backgroundColor: "rgba(140, 133, 135, 0.2)",
                    "&:hover": { backgroundColor: "#fdce0d" },
                  }}
                >
                  <Icon />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Feedback */}
          {/* Contact Us */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Typography sx={{ fontSize: "20px", fontWeight: "bold", mb: 2 }}>
              Contact Us
            </Typography>
            <Divider
              sx={{
                width: "50px",
                borderWidth: "2px",
                backgroundColor: "#8c8587",
                mb: 2,
              }}
            />

            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <LanguageIcon sx={{ mr: 2, fontSize: "24px" }} />
              <Typography
                sx={{ fontSize: "16px", ":hover": { color: "#fdce0d" } }}
              >
                https://www.podarprepyelahanka.com/
              </Typography>
            </Box>

            {/* Email */}
            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <EmailIcon sx={{ mr: 2, fontSize: "24px" }} />
              <Typography
                sx={{ fontSize: "16px", ":hover": { color: "#fdce0d" } }}
              >
                ppyelahanka@podarprep.com
              </Typography>
            </Box>

            {/* Phone */}
            <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
              <PhoneIcon sx={{ mr: 2, fontSize: "24px" }} />
              <Typography
                sx={{ fontSize: "16px", ":hover": { color: "#fdce0d" } }}
              >
                +91 9844565757
              </Typography>
            </Box>

            {/* Website */}

            {/* Address */}
            <Box display="flex" alignItems="center">
              <LocationOnIcon sx={{ mr: 2, fontSize: "24px" }} />
              <Typography
                sx={{ fontSize: "16px", ":hover": { color: "#fdce0d" } }}
              >
                9A1 9A2, Yelahanka Satellite Town, Next to KK Kids Hospital,
                Yelahanka, Bengaluru, Karnataka 560064
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Bottom Bar */}
      <Box
        sx={{
          backgroundColor: "#fdce0d",
          p: 2,
          textAlign: "center",
          color: "black",
          fontWeight: "bold",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
          © 2025 podarprepyelahanka.com All Rights Reserved | Developed by SN
          Info Systems.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
